import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControlStatus } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ValidationMessageService } from '../../services/form-validation-message/form-validation-message.service';
import { VALIDATION_CLASSES, VALIDATION_ERROR_MESSAGES, VALIDATION_STATES } from '../../enums/form-control.enums';

@Directive({
    selector: '[paceCoreValidationMessage]',
})
export class FormValidationMessageDirective implements OnInit, OnDestroy {
    @Input()
    public validation: AbstractControl;

    private errorMessage: string;
    private formControlDestroy: Subject<void> = new Subject<void>();
    private messageDiv?: HTMLDivElement;
    public constructor(
        private readonly el: ElementRef<HTMLElement>,
        private readonly validationMessageService: ValidationMessageService,
    ) {
        this.errorMessage = this.validationMessageService.setValidationMessage(this.validation?.errors);
    }

    public ngOnInit(): void {
        this.createValidationMessageDiv();
        this.setValidationState(this.validation.status);

        this.validation.statusChanges
            .pipe(takeUntil(this.formControlDestroy))
            .subscribe((value) => this.setValidationState(value));
    }

    public ngOnDestroy(): void {
        this.formControlDestroy.next();
    }

    private createValidationMessageDiv(): void {
        this.messageDiv = document.createElement('div');
        this.messageDiv.classList.add('validation-message', VALIDATION_CLASSES.INVALID_FEEDBACK);
        this.el.nativeElement.parentElement?.insertAdjacentElement('beforeend', this.messageDiv);
    }

    private setValidationState(value?: FormControlStatus): void {
        if (value === VALIDATION_STATES.DISABLED) {
            this.disableValidation();
        } else {
            this.errorMessage = this.validationMessageService.setValidationMessage(this.validation.errors);
            this.updateHtmlElements();
        }
    }

    private updateHtmlElements(): void {
        // set bootstrap validation classes
        this.el.nativeElement.classList.remove(VALIDATION_CLASSES.IS_INVALID, VALIDATION_CLASSES.IS_VALID);
        if (this.validation.valid) {
            this.el.nativeElement.classList.add(VALIDATION_CLASSES.IS_VALID);
        } else {
            this.el.nativeElement.classList.add(VALIDATION_CLASSES.IS_INVALID);
        }

        // update the validation message
        this.validationMessageService.setValidationMessage(this.validation.errors);
        if (this.messageDiv) {
            this.messageDiv.innerText = this.errorMessage ?? VALIDATION_ERROR_MESSAGES.empty;
        }
    }

    private disableValidation(): void {
        this.el.nativeElement.classList.remove(VALIDATION_CLASSES.IS_INVALID, VALIDATION_CLASSES.IS_VALID);
    }
}
